var base = require('settings/payment-method-stripe');

Vue.component('spark-payment-method-stripe', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/payment-method-stripe.js